import { render, staticRenderFns } from "./BuildingDetailForm.vue?vue&type=template&id=5a29f033&"
import script from "./BuildingDetailForm.vue?vue&type=script&lang=js&"
export * from "./BuildingDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports